import React, { useState, useEffect } from "react";
import "./userList.css";
import { Breadcrumb, Button, Select, Table, Input, Image, Modal } from "antd";
import { callApi } from "../../api/apiCaller";
import routes from "../../api/routes";
import Loader from "../../components/loader/loader";
import moment from "moment/moment";
import FreeUser from "../../components/addFreeUser/addFree";

import {
  crossIcon,
  homeIcon,
  editIcon,
  redTrash,
  trueIcon,
} from "../../assets";
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [updateRecordData, setUpdateRecordData] = useState(null);
  const [isAddCategoryModalVisible, setIsAddCategoryModalVisible] =
    useState(false);
const [pagination, setPagination] = useState({
  current: 1,
  pageSize: 50,
  total: 0,
});

const getAllUser = async (page = 1, limit = 50) => {
  let getRes = (res) => {
    setUsers(res?.data?.users);

    setPagination({
      current: res?.data?.pagination?.page,
      pageSize: res?.data?.pagination?.limit,
      total: res?.data?.pagination?.total,
    });
  };

  await callApi(
    "GET",
    `${routes.getUsers}?page=${page}&limit=${limit}`,
    null,
    setIsLoading,
    getRes,
    (error) => {
      console.log("error,,", error);
    }
  );
};
const handleTableChange = (newPagination) => {
  getAllUser(newPagination.current, newPagination.pageSize);
};
  useEffect(() => {
    getAllUser(1, pagination.pageSize);
  }, []);

  const blocked = async (ind, event, email, blockStatus) => {
    event.stopPropagation();
    let i = ind;
    let updatedUsers = [...users];
    updatedUsers[i].isBlocked = blockStatus;
    let data = {
      email: email,
      isBlocked: blockStatus,
    };
    console.log("data:::", data);

    let getRes = (res) => {
      console.log("Resp>::::>>>....", res);
    };

    callApi("PATCH", routes.blockUser, data, setIsLoading, getRes, (error) => {
      console.log("error", error);
    });

    setUsers(updatedUsers);
  };
  const makeFree = async (record) => {
    console.log("Record passed to makeFree:", record);
    const selectedCategory = users.find((user) => user._id === record);
    console.log("selected Category???", selectedCategory);
    setUpdateRecordData(selectedCategory);
    setIsAddCategoryModalVisible(true);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "fullName",
      className: "role-name-column-header",
      align: "center",
    },
    {
      title: "Email",
      dataIndex: "email",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "City",
      dataIndex: "city",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Age",
      dataIndex: "age",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Gender",
      dataIndex: "Gender",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Registration Date",
      dataIndex: "createdAt",
      align: "center",
      className: "action-column-header",
      width: 200,
    },
    {
      title: "Role",
      dataIndex: "role",
      align: "center",
      className: "action-column-header",
      width: 200,
    },
    {
      title: "Profile Picture",
      dataIndex: "profilePicture",
      align: "center",
    },
    {
      title: "Verified",
      dataIndex: "verified",
      align: "center",
      className: "action-column-header",
    },
    {
      title: "Block User",
      dataIndex: "blockORUnblock",
      align: "center",
      className: "action-column-header",
      render: (text, record) => (
        <div className="server-roles-trash-btn">
          {record.isBlocked ? (
            <Button
              className="server-roles-trash-btn"
              style={{
                width: "80px",
                color: "white",
                backgroundColor: "#52c41a",
              }}
              onClick={(event) => {
                console.log("unblock", record.email);
                return blocked(record.key, event, record.email, false);
              }}
            >
              Unblock
            </Button>
          ) : (
            <Button
              className="server-roles-trash-btn"
              style={{
                width: "80px",
                color: "white",
                backgroundColor: "#f5222d",
              }}
              onClick={(event) => {
                console.log("block", record.email);
                return blocked(record.key, event, record.email, true);
              }}
            >
              Block
            </Button>
          )}
        </div>
      ),
    },
    {
      title: "Payment Status",
      dataIndex: "isFree",
      align: "center",
      className: "action-column-header",
    },
    {
      title: "Action",
      dataIndex: "_id",
      className: "type-name-column-header",
      align: "center",
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap" }}>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => makeFree(record._id)}
            style={{ marginRight: 8 }}
          ></Button>
        </div>
      ),
      width: "auto",
    },
  ];

  const data = users
    ?.map((item, index) => {
      return {
        key: index,
        _id: item?._id,
        fullName: item?.name,
        age: item?.age,
        city: item?.city,
        gender: item?.gender,
        role: item?.role,
        email: item?.email,
        location: item?.location?.address,
        isFree: item?.isFree ? "Free" : "Paid",
        createdAt: moment(item?.createdAt).format("MM-DD-YYYY"),
        profilePicture: (
          <div className="product-list-image">
            <Image
              style={{
                width: 100,
                height: 100,
                borderRadius: 50,
                objectFit: "cover",
              }}
              src={item?.image}
              alt="profile-image"
            />
          </div>
        ),
        verified: (
          <div className="server-roles-trash-btn">
            <img src={item?.verified ? trueIcon : crossIcon} alt="" />
          </div>
        ),
        isBlocked: item?.isBlocked,
      };
    })
    .filter((item) => {
      const usernameMatch = item.fullName
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      const emailMatch = item.email
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      return usernameMatch || emailMatch;
    });

  const getRowClassName = (record, index) => {
    if (index % 2 === 0) {
      return "server-role-even-row";
    }
    return "server-role-odd-row";
  };

  const handleViewDetails = async (record) => {
    let getRes = (res) => {
      setSelectedUser(res?.user);
      setModalVisible(true);
    };

    const result = await callApi(
      "GET",
      `${routes.getUserData}/${record._id}`,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
      }
    );
  };
  const handleCloseModal = () => {
    setSelectedUser(null);
    setModalVisible(false);
  };

  return (
    <div className="admin-products-main-container">
      <Loader loading={isloading} />
      <Breadcrumb separator=">" className="bread-crumb">
        <div className="configure-server-home-icon">
          <img src={homeIcon} alt="home-icon" />
        </div>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>Users</Breadcrumb.Item>
      </Breadcrumb>
      <div className="configure-server-roles-main-heading-container">
        <h1>Users</h1>
        <div></div>
        <div className="search-inputs" style={{ width: "30rem" }}>
          <Input
            placeholder="Search Name or Email"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      </div>
      <div className="server-roles-tb-main-container">
      <Table
  rowClassName={getRowClassName}
  columns={columns}
  dataSource={data}
  pagination={{
    current: pagination.current,
    pageSize: pagination.pageSize,
    total: pagination.total,
    showSizeChanger: true,
  }}
  onChange={handleTableChange}
  className="subscriptionapi-table"
/>
      </div>
      <Modal
        title={
          <span
            className={
              modalVisible
                ? "blink-animation user-details-label"
                : "user-details-label"
            }
          >
            User Details 👇
          </span>
        }
        visible={modalVisible}
        onCancel={handleCloseModal}
        footer={null}
      >
        {selectedUser && (
          <div style={{ padding: "20px" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  marginRight: "20px",
                  fontWeight: "bold",
                  fontSize: "30px",
                  animation: "fadeIn 1s ease",
                }}
              >
                {`${selectedUser?.fullName}`}
              </div>
              <div style={{ marginLeft: "150px" }}>
                <Image
                  style={{
                    borderRadius: "50%",
                    width: "140px",
                    height: "140px",
                  }}
                  src={selectedUser?.image}
                  alt="profile-image"
                />
              </div>
            </div>
          </div>
        )}
      </Modal>

      <FreeUser
        visible={isAddCategoryModalVisible}
        toggleModal={() => {
          setIsAddCategoryModalVisible(false);
          getAllUser();
        }}
        recordData={updateRecordData}
      />
    </div>
  );
};

export default UserList;
